import { Location } from '@angular/common';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { isSloneekApiRequest, SloneekOriginHeader, sloneekOriginHeaderValue } from '@app/auth/interceptors/sloneek-origin.utils';

export const sloneekOriginInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (!isSloneekApiRequest(request.url)) {
    return next(request);
  }

  const location = inject(Location);

  return next(
    request.clone({
      setHeaders: {
        [SloneekOriginHeader]: sloneekOriginHeaderValue(location.path()),
      },
    }),
  );
};
